module.exports = __webpack_public_path__ + "static/media/1.1ecb2b9f.png";